import {translate} from "../../common/Translator";
import * as BSEntities from "../../constants/BSEntities";
import * as NamaURLS from "../../constants/NamaURLS";
import {ajaxJSON} from "../../common/NamaCommon";

export class ListViewSortByBar {
    constructor(presenter, container) {
        let that = this;
        that.presenter = presenter;
        that.container = container;
    }

    get ascending() {
        let data = this.container.find("#ascDescGroup").data("kendoButtonGroup");
        return data.current().index() == 0;
    }

    set ascending(asc) {
        let ascValue = "asc";
        if (!asc || asc === "false")
            ascValue = "desc";
        this.container.find("#ascDescGroup").data("kendoButtonGroup").select(ascValue == "asc" ? 0 : 1);
    }

    calcSortBy() {
        let that = this;
        let sortByFields = that.container.find("#sortOn").data("kendoMultiSelect").value();
        let sortBy = "";
        for (let field of sortByFields) {
            if (!sortBy.contains(field))
                sortBy += field + ",";
        }
        sortBy = sortBy.substring(0, sortBy.length - 1);
        return sortBy;
    }

    render() {
        let that = this;
        let sortOnField = that.container.find("#sortOn");
        let ascOrDesc = that.container.find("#ascDescGroup");
        that.model = kendo.data.Model.define({});
        Object.defineProperty(that.model.prototype, "$translatedFieldId", {
            enumerable: false, configurable: true, get: function () {
                return translate(this.id, that.presenter.entityType);
            }, set: function (value) {
            }
        });
        sortOnField.kendoMultiSelect(that.sortByOptions());
        sortOnField.parent().find("input.k-input-inner").attr("placeholder", translateId("sortOn"));
        ascOrDesc.kendoButtonGroup({
            items: [
                {text: translate("asc", that.presenter.entityType)},
                {text: translate("desc", that.presenter.entityType)},
            ],
            select: function (e) {
                that.presenter.place.ascending = ascOrDesc.data("kendoButtonGroup").current().index() == 0;
                that.presenter.onListView();
            }
        });
        let place = that.presenter.place;
        let orderBy = that.presenter.getOrderBy();
        let asc = that.presenter.place.ascending;
        if (asc === false) {
            that.presenter.place.ascending = asc;
        }
        if (orderBy) {
            that.presenter.place.sortBy = orderBy;
            let sortByList = orderBy.split(",");
            if (sortByList.length) {
                sortOnField.data("kendoMultiSelect").value(sortByList);
            }
        }
        that.ascending = place.ascending;
        if (place.extraCriteria) {
            ajaxJSON(NamaURLS.FIND_REF_BY_ID, {
                entityType: BSEntities.CriteriaDefinition,
                id: place.extraCriteria
            }, (ref) => {
                that.presenter.extraCriteriaWidget.oldValue = ref;
                that.presenter.extraCriteriaWidget.setValueInElement(ref);
            })
        }
    }

    sortByOptions() {
        let that = this;
        let sortColumns = that.presenter.preferences.listLayout.sortColumns;
        return {
            dataSource: new kendo.data.DataSource({
                data: sortColumns,
                schema: {
                    model: that.model
                }
            }),
            dataTextField: "$translatedFieldId",
            dataValueField: "id",
            filter: "contains",
            placeholder: translateId("sortOn"),
            change: e => {
                that.presenter.place.sortBy = that.calcSortBy();
                that.presenter.onListView();
            }
        };
    }

    onDataChanged(fieldId, fieldValue) {
        let that = this;
        that.presenter.place.extraCriteria = fieldValue ? fieldValue.id : null;
        that.presenter.onListView();
    }

    addDataWidget(widget) {
        this.extraCriteriaWidget = widget;
    }

    rootElement() {
        return this.container;
    }
}